import { Grid, List, ListItem, ListItemText } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import React from "react";
import Blog2 from "assets/images/home-page-images/Blog2.png";

import { Container } from "@mui/material";
import Header from "../components/header";
import Footer from "../components/footer.js";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { NavLink, useNavigate } from "react-router-dom";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { Helmet } from "react-helmet-async";

const Customers = () => {
   const navigate = useNavigate();
  const Content = [
    {
      heading: "What Does AI Mean in Restaurant Marketing?",
      description:
        "In simple terms, AI in restaurant marketing means using smart software that can “think” in a limited way by analyzing data, spotting patterns, and automating repetitive tasks.",
    },
  ];
  const [showButton, setShowButton] = React.useState(false);
  const [bottomOffset, setBottomOffset] = React.useState(20);
  console.log(bottomOffset, "bottom ");
  // Track scroll position
  React.useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const isMobile = window.matchMedia("(max-width: 768px)").matches;
      const mobileBottomOffset = 395;
      const desktopBottomOffset = 320;

      setShowButton(scrollY > 500);

      if (windowHeight + scrollY >= documentHeight - 100) {
        setBottomOffset(isMobile ? mobileBottomOffset : desktopBottomOffset);
      } else {
        setBottomOffset(20);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const itemOne = [
    "Works 24/7",
    "Never takes a lunch break",
    "Gives you insights based on facts not guesses",
  ];
  const itemTwo = [
    "Managing online reviews",
    "Predicting sales and busy periods",
    "Personalizing promotions",
    "Generating social media content ideas",
    "Analyzing customer feedback",
  ];

  const itemThree = [
    "Monitor reviews across Google, Yelp, TripAdvisor, and social media",
    "Flag negative comments so you can respond quickly",
    "Suggest professional replies that match your brand",
    "Track sentiment trends like recurring praise for a menu item or repeated complaints about service speed",
  ];
  const itemFour = [
    "Plan your menu, such as stocking more iced drinks during heat waves",
    "Schedule staff for busy times",
    "Time promotions for the best impact",
  ];

  const itemFive = [
    "A customer who hasn’t visited in a month might receive a “We miss you” offer",
    "A person who always orders pasta could get a heads-up about your new Italian menu night",
    "Loyal customers may receive a birthday discount",
  ];

  const itemSix = [
    "Answer FAQs instantly",
    "Help customers book a table",
    "Suggest menu items based on preferences",
    "Process orders without human help",
  ];

  const itemSeven = [
    "Suggesting post ideas based on trending food topics",
    "Writing captions that match your brand voice",
    "Analyzing which posts get the most engagement",
    "Creating short videos or image templates",
  ];

  const itemEight = [
    "What dishes people love",
    "Which service issues come up often",
    "How customers feel about your pricing or atmosphere",
  ];

  const itemNine = [
    "Keep ahead of trends",
    "Respond in real time",
    "Make decisions based on data, not hunches",
  ];
  const itemTen = [
    "A review management tool",
    "An AI-powered email platform",
    "A chatbot for your reservations page",
  ];
  const itemEleven = [
    "<strong>Pick one high-impact area</strong>  For many restaurants, review management is the best first step that directly ties to reputation and revenue.",
    `<strong>Choose a beginner-friendly tool</strong> Look for something with a user-friendly dashboard, clear reports, and automation options.`,
    `<strong>Track your results</strong>  Measure before and after: response times, review ratings, customer visits, or sales from promotions.`,
    "<strong>Expand gradually</strong> a Once you see results, add more AI tools like predictive analytics or social media automation.",
  ];

  const itemTwelve = [
    "Average Google rating rose from 4.1 to 4.6",
    "85% of reviews were replied to within 24 hours, compared to a week before",
    "Negative reviews dropped by 40% after the restaurant addressed common complaints about slow lunch service",
  ];
  return (
    <MDBox
      sx={{
        width: "100%",
        maxWidth: {
          xs: "100%",
          md: "1580px",
          xl: "1920px",
        },
        mx: "auto",
        // px: 2,
      }}
    >
      <Helmet>
        <title>
          {" "}
          Everything you need to know about AI Restaurant Marketing
        </title>
        <meta
          name="description"
          content=" Discover how AI is transforming restaurant marketing in 2026, boost reviews, personalize promotions, and grow your business faster."
        />
        <meta name="keywords" content="Restaurant Marketing" />
      </Helmet>
      <Header></Header>

      <MDBox
        sx={{
          py: 3,
          mt: { xs: 4, sm: 4, md: 16 },
          mb: 4,
          zIndex: 1,
          backgroundColor: "#fff",
          position: "relative",
        }}
      >
        <MDBox
          sx={{
            position: "absolute",
            top: {
              xs: 20,
              xm: 25,
              md: 10,
            },
            left: {
              xs: 10,
              xm: 25,
              md: 50,
            },
            fontSize: {
              xs: "20px",
              xm: "40px",
              md: "40px",
            },
            color: "gray",
          }}
        >
          <MDBox 
           onClick={() => navigate(-1)}
           style={{ textDecoration: "none" }}>
            <KeyboardBackspaceIcon sx={{ color: "gray", fontSize: "40px" }} />
          </MDBox>
        </MDBox>

        <Container
          sx={{
            "@media (min-width:1580px)": { maxWidth: "1600px!important" },
          }}
        >
          <Grid
            container
            spacing={0}
            sx={{
              alignItems: "center",
              width: { xs: "100%", sm: "90%", md: "90%" },
              margin: "auto",
            }}
          >
            {/* Left Side: Heading + Description */}
            <Grid
              item
              xs={6}
              md={5}
              sx={{
                mt: {
                  xs: 5,
                  sm: 0,
                  md: 0,
                },
              }}
            >
              <MDBox
                sx={{
                  width: {
                    xs: "100%",
                    sm: "90%",
                  },
                  pl: {
                    xs: 1,
                    sm: 1,
                    md: -2,
                  },

                  textAlign: "start",
                }}
              >
                <MDTypography
                  variant="h3"
                  sx={{
                    fontWeight: "600",
                    fontSize: {
                      xs: "11px",
                      md: "14px",
                      color: "#F47C00",
                      letterSpacing: 0.7,
                      fontFamily: "Poppins",
                    },
                  }}
                >
                  Latest
                </MDTypography>
                <MDTypography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: {
                      xs: "15px",
                      md: "38px",
                    },
                    fontFamily: "Poppins",
                    color: "#318BEC",
                  }}
                >
                  AI in Restaurant Marketing: What You Need to Know
                </MDTypography>
                <MDTypography
                  variant="body1"
                  sx={{
                    mt: {
                      xs: 1,
                      md: 2,
                    },
                    fontSize: {
                      xs: "7px",
                      md: "14px",
                    },
                    fontWeight: 500,
                    fontFamily: "Poppins",
                    color: "#000",
                  }}
                >
                  13th August, 2025
                </MDTypography>
              </MDBox>
            </Grid>

            {/* Right Side: Image */}
            <Grid
              item
              xs={6}
              md={7}
              sx={{
                mt: {
                  xs: 4,
                  sm: 0,
                  md: 0,
                },
              }}
            >
              <MDBox sx={{ pl: "5%", pb: "4%" }}>
                <MDBox
                  component="img"
                  src={Blog2}
                  // src="https://placehold.co/700x400?text=Coming+Soon"
                  alt="AI dashboard"
                  sx={{
                    display: "block",
                    mx: "auto", // center image
                    width: {
                      xs: "215px",
                      sm: "320px",
                      md: "490px",
                      lg: "550px",
                      xl: "600px",
                    },
                    height: {
                      xs: "128px",
                      sm: "200px",
                      md: "240px",
                      lg: "300px",
                      xl: "340px",
                    },
                    borderRadius: {
                      xs: "5px",
                      sm: "16px",
                      md: "16px",
                    },
                    boxShadow: "3px 6px 20px 3px #00000066",
                  }}
                />
              </MDBox>
            </Grid>
          </Grid>

          <MDBox
            sx={{
              width: {
                xs: "95%",
                sm: "90%",
                md: "90%",
              },
              margin: "auto",
            }}
          >
            <MDTypography
              variant="body1"
              sx={{
                mt: 2,
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                color: "#000",
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Restaurant marketing has changed a lot over the past decade.
              Flyers, radio spots, and word-of-mouth still matter, but in 2026,
              artificial intelligence (AI) is changing how restaurants attract,
              engage, and retain customers.
            </MDTypography>

            <MDTypography
              variant="body1"
              sx={{
                my: 2,
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                color: "#000",
                textAlign: "justify",
              }}
            >
              Whether you run a cozy local café, a busy fast-casual spot, or a
              growing multi-location brand, AI offers tools that can help you
              work smarter, respond faster, and create more personalized
              experiences.
            </MDTypography>
            <MDTypography
              variant="body1"
              sx={{
                my: 2,
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                color: "#000",
                textAlign: "justify",
              }}
            >
              The best part is that you don’t need a huge budget or a tech
              degree to get started.
            </MDTypography>
            <MDTypography
              variant="body1"
              sx={{
                my: 2,
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                color: "#000",
                textAlign: "justify",
              }}
            >
              This guide will explain what AI in{" "}
              <NavLink
                style={{
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  color: "blue",
                  textDecoration: "none",
                }}
                to="https://tavloai.com/"
              >
                restaurant marketing
              </NavLink>{" "}
              means, how it's being used today, and how you can start using it
              to grow your business without feeling overwhelmed.
            </MDTypography>

            <MDBox
              sx={{
                mb: {
                  xs: 2,
                  sm: 3,
                  md: 5,
                },
              }}
            >
              {Content.map((item, index) => (
                <MDBox key={index} mb={2}>
                  <MDTypography
                    variant="h6"
                    sx={{
                      color: "#000",
                      fontWeight: 900,
                      fontFamily: "Poppins",
                      mb: {
                        xs: 0.4,
                        sm: 3,
                        md: 3,
                      },
                      fontSize: {
                        xs: "12px",
                        sm: "14px",
                        md: "1rem",
                      },
      // fontWeight:600,                      fontFamily: "Poppins",
                    }}
                  >
                    {item.heading}
                  </MDTypography>
                  <MDTypography
                    variant="body2"
                    sx={{
                      color: "#000",
                      fontFamily: "Poppins",
                      mb: {
                        xs: 1,
                        sm: 3,
                        md: 3,
                      },
                      fontSize: {
                        xs: "10.5px",
                        sm: "14px",
                        md: "1rem",
                      },
                      fontFamily: "Poppins",
                      textAlign: "justify",
                    }}
                  >
                    {item.description}
                  </MDTypography>
                </MDBox>
              ))}
            </MDBox>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Think of it as having a marketing assistant that:
            </MDTypography>
            <List sx={{ mb: { xs: 0, sm: 1, md: 3 } }}>
              {itemOne.map((item, index) => (
                <ListItem key={index} disableGutters alignItems="flex-start">
                  <MDBox
                    sx={{
                      marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                      fontSize: "6px",
                      mr: 1,
                      lineHeight: 2.2,
                      mt: {
                        xs: "5px",
                        sm: "10px",
                        md: "15px",
                      },
                    }}
                  >
                    <FiberManualRecordIcon sx={{ color: "#000" }} />
                  </MDBox>
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{
                      sx: {
                        fontFamily: "urbanist",
                        fontWeight: 400,
                        fontSize: {
                          xs: "10px",
                          sm: "14px",
                          md: "16px",
                        },
                        color: "#000",
                        fontFamily: "Poppins",
                        lineHeight: {
                          xs: 2.1,
                          sm: 2.2,
                          md: 2.2,
                        },
                      },
                    }}
                  />
                </ListItem>
              ))}
            </List>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              It’s not out to replace your creativity or personal touch; it’s
              here to handle the time-consuming tasks so you can focus on the
              human side of hospitality.
            </MDTypography>

            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Some common uses of AI in restaurants today include:
            </MDTypography>
            <List sx={{ mb: { xs: 0, sm: 1, md: 3 } }}>
              {itemTwo.map((item, index) => (
                <ListItem key={index} disableGutters alignItems="flex-start">
                  <MDBox
                    sx={{
                      marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                      fontSize: "6px",
                      mr: 1,
                      lineHeight: 2.2,
                      mt: {
                        xs: "5px",
                        sm: "10px",
                        md: "15px",
                      },
                    }}
                  >
                    <FiberManualRecordIcon sx={{ color: "#000" }} />
                  </MDBox>
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{
                      sx: {
                        fontFamily: "urbanist",
                        fontWeight: 400,
                        fontSize: {
                          xs: "10px",
                          sm: "14px",
                          md: "16px",
                        },
                        color: "#000",
                        fontFamily: "Poppins",
                        lineHeight: {
                          xs: 2.1,
                          sm: 2.2,
                          md: 2.2,
                        },
                      },
                    }}
                  />
                </ListItem>
              ))}
            </List>
            <MDTypography
              variant="h1"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 2,
                  md: 2,
                },
                fontSize: {
                  xs: "18.5px",
                  sm: "18px",
                  md: "1.5rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              6 Ways AI Is Transforming Restaurant Marketing
            </MDTypography>
            <MDTypography
              variant="h1"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 2,
                  sm: 3,
                  md: 5,
                },
                fontSize: {
                  xs: "14.5px",
                  sm: "14px",
                  md: "1rem",
                },
// fontWeight:600,                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              1. Smart Review Management
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Reviews can make or break a restaurant. Positive reviews boost
              your reputation and search rankings, while unanswered negative
              ones can scare off potential customers.
            </MDTypography>

            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              AI-powered tools like TavloAI can:
            </MDTypography>
            <List sx={{ mb: { xs: 0, sm: 1, md: 3 } }}>
              {itemThree.map((item, index) => (
                <ListItem key={index} disableGutters alignItems="flex-start">
                  <MDBox
                    sx={{
                      marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                      fontSize: "6px",
                      mr: 1,
                      lineHeight: 2.2,
                      mt: {
                        xs: "5px",
                        sm: "10px",
                        md: "15px",
                      },
                    }}
                  >
                    <FiberManualRecordIcon sx={{ color: "#000" }} />
                  </MDBox>
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{
                      sx: {
                        fontFamily: "urbanist",
                        fontWeight: 400,
                        fontSize: {
                          xs: "10px",
                          sm: "14px",
                          md: "16px",
                        },
                        color: "#000",
                        fontFamily: "Poppins",
                        lineHeight: {
                          xs: 2.1,
                          sm: 2.2,
                          md: 2.2,
                        },
                      },
                    }}
                  />
                </ListItem>
              ))}
            </List>

            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Pro Tip: Respond to all reviews, not just the negative ones. Thank
              happy customers and address issues directly with unhappy ones. AI
              helps speed up this process and keeps it consistent.{" "}
            </MDTypography>

            <MDTypography
              variant="h1"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 2,
                  sm: 3,
                  md: 5,
                },
                fontSize: {
                  xs: "14.5px",
                  sm: "14px",
                  md: "1rem",
                },
                // fontWeight:600,
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              2. Predictive Analytics
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Ever wish you could see into the future? Predictive analytics
              comes close.
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              AI looks at your past sales, seasonal trends, weather patterns,
              and local events to forecast what’s likely to happen next. This
              helps you:
            </MDTypography>
            <List sx={{ mb: { xs: 0, sm: 1, md: 3 } }}>
              {itemFour.map((item, index) => (
                <ListItem key={index} disableGutters alignItems="flex-start">
                  <MDBox
                    sx={{
                      marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                      fontSize: "6px",
                      mr: 1,
                      lineHeight: 2.2,
                      mt: {
                        xs: "5px",
                        sm: "10px",
                        md: "15px",
                      },
                    }}
                  >
                    <FiberManualRecordIcon sx={{ color: "#000" }} />
                  </MDBox>
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{
                      sx: {
                        fontFamily: "urbanist",
                        fontWeight: 400,
                        fontSize: {
                          xs: "10px",
                          sm: "14px",
                          md: "16px",
                        },
                        color: "#000",
                        fontFamily: "Poppins",
                        lineHeight: {
                          xs: 2.1,
                          sm: 2.2,
                          md: 2.2,
                        },
                      },
                    }}
                  />
                </ListItem>
              ))}
            </List>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              For instance, a beachside café could use AI data to predict an
              increase in foot traffic during a local festival and prepare extra
              inventory ahead of time.
            </MDTypography>

            <MDTypography
              variant="h1"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 2,
                  sm: 3,
                  md: 5,
                },
                fontSize: {
                  xs: "14.5px",
                  sm: "14px",
                  md: "1rem",
                },
// fontWeight:600,                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              3. Personalized Restaurant Marketing
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Generic
              <NavLink
                style={{
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  color: "blue",
                  textDecoration: "none",
                }}
                to="https://tavloai.com/"
              >
                Restaurant Marketing
              </NavLink>
              is easy to ignore. AI changes this by sending the right message to
              the right person at the right time.
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              For example:
            </MDTypography>
            <List sx={{ mb: { xs: 0, sm: 1, md: 3 } }}>
              {itemFive.map((item, index) => (
                <ListItem key={index} disableGutters alignItems="flex-start">
                  <MDBox
                    sx={{
                      marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                      fontSize: "6px",
                      mr: 1,
                      lineHeight: 2.2,
                      mt: {
                        xs: "5px",
                        sm: "10px",
                        md: "15px",
                      },
                    }}
                  >
                    <FiberManualRecordIcon sx={{ color: "#000" }} />
                  </MDBox>
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{
                      sx: {
                        fontFamily: "urbanist",
                        fontWeight: 400,
                        fontSize: {
                          xs: "10px",
                          sm: "14px",
                          md: "16px",
                        },
                        color: "#000",
                        fontFamily: "Poppins",
                        lineHeight: {
                          xs: 2.1,
                          sm: 2.2,
                          md: 2.2,
                        },
                      },
                    }}
                  />
                </ListItem>
              ))}
            </List>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              AI can automate these campaigns through email, SMS, or push
              notifications, making them timely and relevant, which increases
              the chance of conversion.
            </MDTypography>

            <MDTypography
              variant="h1"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 2,
                  sm: 3,
                  md: 5,
                },
                fontSize: {
                  xs: "14.5px",
                  sm: "14px",
                  md: "1rem",
                },
// fontWeight:600,                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              4. Chatbots and Online Ordering
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              AI-powered chatbots now handle everything from answering “What’s
              on the menu?” to taking full orders.
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              On your website or social media, they can:
            </MDTypography>
            <List sx={{ mb: { xs: 0, sm: 1, md: 3 } }}>
              {itemSix.map((item, index) => (
                <ListItem key={index} disableGutters alignItems="flex-start">
                  <MDBox
                    sx={{
                      marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                      fontSize: "6px",
                      mr: 1,
                      lineHeight: 2.2,
                      mt: {
                        xs: "5px",
                        sm: "10px",
                        md: "15px",
                      },
                    }}
                  >
                    <FiberManualRecordIcon sx={{ color: "#000" }} />
                  </MDBox>
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{
                      sx: {
                        fontFamily: "urbanist",
                        fontWeight: 400,
                        fontSize: {
                          xs: "10px",
                          sm: "14px",
                          md: "16px",
                        },
                        color: "#000",
                        fontFamily: "Poppins",
                        lineHeight: {
                          xs: 2.1,
                          sm: 2.2,
                          md: 2.2,
                        },
                      },
                    }}
                  />
                </ListItem>
              ))}
            </List>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              This means fewer missed reservations and quicker service for
              customers especially during busy hours when your staff is
              stretched thin.
            </MDTypography>

            <MDTypography
              variant="h1"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 2,
                  sm: 3,
                  md: 5,
                },
                fontSize: {
                  xs: "14.5px",
                  sm: "14px",
                  md: "1rem",
                },
// fontWeight:600,                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              5. Social Media Content Generation
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Keeping your social media active is a full-time job. AI can
              simplify it by:
            </MDTypography>

            <List sx={{ mb: { xs: 0, sm: 1, md: 3 } }}>
              {itemSeven.map((item, index) => (
                <ListItem key={index} disableGutters alignItems="flex-start">
                  <MDBox
                    sx={{
                      marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                      fontSize: "6px",
                      mr: 1,
                      lineHeight: 2.2,
                      mt: {
                        xs: "5px",
                        sm: "10px",
                        md: "15px",
                      },
                    }}
                  >
                    <FiberManualRecordIcon sx={{ color: "#000" }} />
                  </MDBox>
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{
                      sx: {
                        fontFamily: "urbanist",
                        fontWeight: 400,
                        fontSize: {
                          xs: "10px",
                          sm: "14px",
                          md: "16px",
                        },
                        color: "#000",
                        fontFamily: "Poppins",
                        lineHeight: {
                          xs: 2.1,
                          sm: 2.2,
                          md: 2.2,
                        },
                      },
                    }}
                  />
                </ListItem>
              ))}
            </List>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              For example, if “pumpkin spice” is trending, AI might suggest
              posting a behind-the-scenes video of your seasonal latte being
              made
            </MDTypography>
            <MDTypography
              variant="h1"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 2,
                  sm: 3,
                  md: 5,
                },
                fontSize: {
                  xs: "14.5px",
                  sm: "14px",
                  md: "1rem",
                },
// fontWeight:600,                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              6. Customer Feedback Analysis
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Reading through hundreds of feedback forms and reviews manually
              can be exhausting. AI can scan them in seconds, summarize the main
              points, and categorize them into themes.
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              This helps you quickly understand:
            </MDTypography>

            <List sx={{ mb: { xs: 0, sm: 1, md: 3 } }}>
              {itemEight.map((item, index) => (
                <ListItem key={index} disableGutters alignItems="flex-start">
                  <MDBox
                    sx={{
                      marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                      fontSize: "6px",
                      mr: 1,
                      lineHeight: 2.2,
                      mt: {
                        xs: "5px",
                        sm: "10px",
                        md: "15px",
                      },
                    }}
                  >
                    <FiberManualRecordIcon sx={{ color: "#000" }} />
                  </MDBox>
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{
                      sx: {
                        fontFamily: "urbanist",
                        fontWeight: 400,
                        fontSize: {
                          xs: "10px",
                          sm: "14px",
                          md: "16px",
                        },
                        color: "#000",
                        fontFamily: "Poppins",
                        lineHeight: {
                          xs: 2.1,
                          sm: 2.2,
                          md: 2.2,
                        },
                      },
                    }}
                  />
                </ListItem>
              ))}
            </List>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              From there, you can act on the insights improving your menu,
              training staff, or adjusting prices.
            </MDTypography>

            <MDTypography
              variant="h1"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 2,
                  sm: 3,
                  md: 5,
                },
                fontSize: {
                  xs: "14.5px",
                  sm: "14px",
                  md: "1rem",
                },
// fontWeight:600,                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Why This Matters in 2026
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Diners expect quick replies, personalized service, and consistent
              quality both in person and online. If you can’t deliver, they’ll
              find someone else who will.
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              At the same time, marketing platforms like Google, Instagram, and
              TikTok change constantly. Algorithms shift, trends can disappear
              overnight, and attention spans are shorter than ever.
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              AI helps restaurants:
            </MDTypography>

            <List sx={{ mb: { xs: 0, sm: 1, md: 3 } }}>
              {itemNine.map((item, index) => (
                <ListItem key={index} disableGutters alignItems="flex-start">
                  <MDBox
                    sx={{
                      marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                      fontSize: "6px",
                      mr: 1,
                      lineHeight: 2.2,
                      mt: {
                        xs: "5px",
                        sm: "10px",
                        md: "15px",
                      },
                    }}
                  >
                    <FiberManualRecordIcon sx={{ color: "#000" }} />
                  </MDBox>
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{
                      sx: {
                        fontFamily: "urbanist",
                        fontWeight: 400,
                        fontSize: {
                          xs: "10px",
                          sm: "14px",
                          md: "16px",
                        },
                        color: "#000",
                        fontFamily: "Poppins",
                        lineHeight: {
                          xs: 2.1,
                          sm: 2.2,
                          md: 2.2,
                        },
                      },
                    }}
                  />
                </ListItem>
              ))}
            </List>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              In short, AI levels the playing field so even small, independent
              restaurants can compete with big brands with
              <NavLink
                style={{
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  color: "blue",
                  textDecoration: "none",
                }}
                to="https://tavloai.com/"
              >
                Restaurant Marketing
              </NavLink>
              AI platform.
            </MDTypography>
            <MDTypography
              variant="h1"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 2,
                  sm: 3,
                  md: 5,
                },
                fontSize: {
                  xs: "14.5px",
                  sm: "14px",
                  md: "1rem",
                },
// fontWeight:600,                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Is AI Only for Big Brands?
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Absolutely not. While big chains have been using AI for years,
              today’s tools are designed to be affordable and easy for small
              businesses.
            </MDTypography>

            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              You can start with something simple like:
            </MDTypography>

            <List sx={{ mb: { xs: 0, sm: 1, md: 3 } }}>
              {itemTen.map((item, index) => (
                <ListItem key={index} disableGutters alignItems="flex-start">
                  <MDBox
                    sx={{
                      marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                      fontSize: "6px",
                      mr: 1,
                      lineHeight: 2.2,
                      mt: {
                        xs: "5px",
                        sm: "10px",
                        md: "15px",
                      },
                    }}
                  >
                    <FiberManualRecordIcon sx={{ color: "#000" }} />
                  </MDBox>
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{
                      sx: {
                        fontFamily: "urbanist",
                        fontWeight: 400,
                        fontSize: {
                          xs: "10px",
                          sm: "14px",
                          md: "16px",
                        },
                        color: "#000",
                        fontFamily: "Poppins",
                        lineHeight: {
                          xs: 2.1,
                          sm: 2.2,
                          md: 2.2,
                        },
                      },
                    }}
                  />
                </ListItem>
              ))}
            </List>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              These tools require little to no technical setup and can start
              paying off almost right away.
            </MDTypography>

            <MDTypography
              variant="h1"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 2,
                  sm: 3,
                  md: 5,
                },
                fontSize: {
                  xs: "14.5px",
                  sm: "14px",
                  md: "1rem",
                },
// fontWeight:600,                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              How to Get Started With AI in Your Restaurant
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              You don’t need to overhaul your entire restaurant marketing system
              overnight. Start small and focus on areas where you’re spending
              too much time or getting unsatisfactory results.
            </MDTypography>

            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Here’s a simple approach:
            </MDTypography>

            <List sx={{ mb: { xs: 0, sm: 1, md: 3 } }}>
              {itemEleven.map((item, index) => (
                <ListItem key={index} disableGutters alignItems="flex-start">
                  <MDBox
                    sx={{
                      marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                      fontSize: "6px",
                      mr: 1,
                      lineHeight: 2.2,
                      mt: { xs: "5px", sm: "10px", md: "10px" },
                    }}
                  >
                    <FiberManualRecordIcon sx={{ color: "#000" }} />
                  </MDBox>
                  <ListItemText
                    primary={
                      <MDTypography
                        variant="h1"
                        fontWeight="medium"
                        sx={{
                          fontFamily: "Poppins",
                          fontWeight: 400,
                          fontSize: { xs: "10px", sm: "14px", md: "16px" },
                          color: "#000",
                          lineHeight: {
                            xs: "15px",
                            sm: "24px",
                            md: 1.6,
                          },
                          mb: {
                            xs: 1,
                            sm: 0,
                            md: 1.5,
                          },
                          textAlign: "justify",
                        }}
                        dangerouslySetInnerHTML={{ __html: item }}
                      />
                    }
                  />
                </ListItem>
              ))}
            </List>

            <MDTypography
              variant="h1"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 2,
                  sm: 3,
                  md: 5,
                },
                fontSize: {
                  xs: "14.5px",
                  sm: "14px",
                  md: "1rem",
                },
// fontWeight:600,                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Real-World Example: A Small Bistro Goes AI
            </MDTypography>

            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              A family-owned bistro in a mid-sized city started using AI for
              review management. Within three months:
            </MDTypography>

            <List sx={{ mb: { xs: 0, sm: 1, md: 3 } }}>
              {itemTwelve.map((item, index) => (
                <ListItem key={index} disableGutters alignItems="flex-start">
                  <MDBox
                    sx={{
                      marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                      fontSize: "6px",
                      mr: 1,
                      lineHeight: 2.2,
                      mt: {
                        xs: "5px",
                        sm: "10px",
                        md: "15px",
                      },
                    }}
                  >
                    <FiberManualRecordIcon sx={{ color: "#000" }} />
                  </MDBox>
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{
                      sx: {
                        fontFamily: "urbanist",
                        fontWeight: 400,
                        fontSize: {
                          xs: "10px",
                          sm: "14px",
                          md: "16px",
                        },
                        color: "#000",
                        fontFamily: "Poppins",
                        lineHeight: {
                          xs: 2.1,
                          sm: 2.2,
                          md: 2.2,
                        },
                      },
                    }}
                  />
                </ListItem>
              ))}
            </List>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Encouraged by these results, they added AI-powered email marketing
              to send personalized offers and saw a 25% increase in repeat
              visits.
            </MDTypography>
            <MDTypography
              variant="h1"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 2,
                  sm: 3,
                  md: 5,
                },
                fontSize: {
                  xs: "14.5px",
                  sm: "14px",
                  md: "1rem",
                },
// fontWeight:600,                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Final Thoughts
            </MDTypography>

            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              AI isn’t taking away the heart of your restaurant, the
              hospitality, the food, and the personal touch. But it can make
              your
              <NavLink
                style={{
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  color: "blue",
                  textDecoration: "none",
                }}
                to="https://tavloai.com/"
              >
                restaurant marketing
              </NavLink>
              smarter, faster, and more effective.
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              The tools are available. The benefits are real. The question is:
              Will you take advantage of them now, or will your competitors get
              there first?{" "}
            </MDTypography>

            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              If you’re ready to see the difference, try
              <NavLink
                style={{
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  color: "blue",
                  textDecoration: "none",
                }}
                to="https://tavloai.com/contact"
              >
                TavloAI
              </NavLink>
              . From managing your reviews to tracking customer sentiment, it’s
              designed to help restaurants grow without adding more to your
              to-do list.{" "}
            </MDTypography>
          </MDBox>
        </Container>

        {showButton && (
          <MDBox
            sx={{
              position: "fixed",
              bottom: bottomOffset,
              right: { xs: 20, md: 35 },
              zIndex: 9999,
            }}
          >
            <MDBox
              onClick={scrollToTop}
              sx={{
                cursor: "pointer",
                p: { xs: 0.5, md: 1 },
                backgroundColor: "#F47C00",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "30px",
              }}
            >
              <ArrowUpwardIcon sx={{ color: "#fff", fontSize: "30px" }} />
            </MDBox>
          </MDBox>
        )}
      </MDBox>
      <Footer></Footer>
    </MDBox>
  );
};

export default Customers;
